import { getIdToken } from './api';
import config from '../config';

export async function createBroadcast() {
  const token = await getIdToken();
  const res = await fetch('/broadcasts', {
    method: 'post',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (res.ok) {
    return res.json();
  } else {
    throw new Error('Failed to create broadcast');
  }
}

export async function getBroadcast(id) {
  const userToken = await getIdToken();
  const res = await fetch(`/broadcasts/${id}`, {
    method: 'get',
    headers: { Authorization: `Bearer ${userToken}` },
  });
  if (res.ok) {
    return res.json();
  } else {
    throw new Error('Failed to get broadcast');
  }
}

export async function getBroadcastToken(id) {
  const userToken = await getIdToken();
  const res = await fetch(`/broadcasts/${id}/token`, {
    method: 'get',
    headers: { Authorization: `Bearer ${userToken}` },
  });
  if (res.ok) {
    return res.json();
  } else {
    throw new Error('Failed to get broadcast token');
  }
}

export async function deleteBroadcast(id) {
  const token = await getIdToken();
  return fetch(`/broadcasts/${id}`, {
    method: 'delete',
    headers: { Authorization: `Bearer ${token}` },
  }).catch((err) => {
    console.log('Failed to delete broadcast', id, err);
  });
}

export async function getClusterStatus() {
  const res = await fetch(`${config.baseUrl}/cluster/status`, {
    method: 'get',
  });
  if (res.ok) {
    return res.json();
  } else {
    throw new Error('Failed to get cluster status');
  }
}

export async function scaleCluster(data) {
  const userToken = await getIdToken();
  const res = await fetch(`/cluster`, {
    method: 'put',
    headers: {
      Authorization: `Bearer ${userToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (res.ok) {
    return res.json();
  } else {
    throw new Error('Failed to scale cluster');
  }
}
